import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  fill: "none",
  viewBox: "0 0 36 36"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#FF5100",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M13.545 25.5h6.3m-6.3 0c0 1.657-1.41 3-3.15 3s-3.15-1.343-3.15-3m6.3 0c0-1.657-1.41-3-3.15-3s-3.15 1.343-3.15 3m12.6 0v-16m0 16h3.15m-3.15-16c0-1.1-.945-2-2.1-2H4.095c-1.155 0-2.1.9-2.1 2v14c0 1.1.945 2 2.1 2h3.15m12.6-16h8.148c.798 0 1.523.43 1.88 1.11l3.622 6.89m-10.5 8c0-1.657 1.41-3 3.15-3s3.15 1.343 3.15 3m-6.3 0c0 1.657 1.41 3 3.15 3s3.15-1.343 3.15-3m4.2-8v8h-4.2m4.2-8h-13.65"
    }, null, -1)
  ]))]))
}
export default { render: render }